/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AsName
 */
export interface AsName {
}

/**
 * Check if a given object implements the AsName interface.
 */
export function instanceOfAsName(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AsNameFromJSON(json: any): AsName {
    return AsNameFromJSONTyped(json, false);
}

export function AsNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): AsName {
    return json;
}

export function AsNameToJSON(value?: AsName | null): any {
    return value;
}

